import React from "react";
import { Link } from "react-router-dom";
import Logo from "../../Assets/Images/company_logo.png";
import "./videobanner.css";

const VideoBanner = ({
  videoUrl,
  heading,
  subheading,
  buttonText,
  buttonLink,
}) => {
  return (
    <div className="video-banner">
      <div className="vb-content">
        {/* LEFT — VIDEO */}
        <div className="vb-video">
          <iframe
            src={videoUrl}
            title="Team Workout Video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>

        {/* RIGHT — LOGO + TITLE + BUTTON */}
        <div className="vb-right">
          <img src={Logo} alt="Company Logo" className="vb-logo" />

          <h2 className="vb-title">{heading}</h2>
          <h2 className="vb-title-two">{subheading}</h2>

          <Link to={buttonLink} className="vb-btn">
            <span className="text-clip">{buttonText}</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default VideoBanner;
